export default "__VITE_ASSET__c3abb269__"